export default function Button({children, buttonStyle, onClick, icon}) {
    return (
        <button className={buttonStyle} onClick={onClick}>
            {icon}
            <h4> {children}</h4>
        </button>
    );
}
